export const prepareItemsForBaseSelect = <T>(items: T[]) => items.map((item) => ({ id: item, value: item }));
